<template>
  <div :class="['roam-view h-100', { 'p-20': !$route.query.isTitle } ]">
    <template v-if="!$route.query.isTitle">
      <h3 class="b-b-1 m-b-10 title">研学漫游预览</h3>
      <Button type="error" size="small" class="extra" to="/config/dataManage/roam">返回</Button>
    </template>
    <div :class="!$route.query.isTitle ? 'roam_panorama': 'roam_content'" v-if="roamType == 'panorama'">
      <panoramaRoam :panoramaList="panorama_list"></panoramaRoam>
    </div>
    <div :class="!$route.query.isTitle ? 'roam_panorama': 'roam_content'"  v-if="roamType == 'point'">
      <pointRoam :marks="point_list"></pointRoam>
    </div>
    <div :class="!$route.query.isTitle ? 'roam_panorama': 'roam_content'"  v-if="roamType == 'line'">
      <lineRoam :detail="line_list"></lineRoam>
    </div>
  </div>
</template>

<script>
import { getRoamById } from '@/libs/api/roam'
import panoramaRoam from './roamType/panoramaRoam.vue'
import pointRoam from './roamType/pointRoam.vue'
import lineRoam from './roamType/lineRoam.vue'
export default {
  components: { panoramaRoam, pointRoam, lineRoam }, 
  data() {
    return {
      roamType: '',
      panorama_list: null,
      point_list: [],
      line_list: {}
    }
  },
  methods: {
    
  },
  async mounted() {
    const { id } = this.$route.query
    if(id) {
      const { code, data } = await getRoamById({ id })
      if(code == "HA0200") {
        this.roamType = data.type
        if(data.type !== 'panorama') {
          // 漫游路线预览
          if(data.type == 'line') {
            let line_content = data.content.map(item => JSON.parse(item))
            // console.log(line_content[0])
            this.line_list = Object.assign({}, this.line_list, {
              ...line_content[0],
              id: "0",
              name: line_content[0].lineName,
              lng: line_content[0].lineCenter.lon,
              lat: line_content[0].lineCenter.lat,
              ele: 1000,
              width: 30,
              height: 30,
              image: "line.svg",
            });
          }else {
            let point_content = data.content.map(item => JSON.parse(item))
            this.point_list = point_content.map((item) => {
              return {
                lng: Number(item.pointCoord.lon),
                lat: Number(item.pointCoord.lat),
                height: 1000,
                flytime: 2,
                name: item.pointName,
                info: item.pointInfo,
                add: `${item.pointAdd[0]}-${item.pointAdd[1]}-${item.pointAdd[2]}`,
                point360: item.point360
              }
            })
            this.point_list
          }
        }else {
          let panorama_content = data.content.map(item => JSON.parse(item))
          this.panorama_list = panorama_content
        }
      }
    }
  },
}
</script>

<style lang="less" scoped>

.roam-view {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .title {
    height: 30px;
  }
  .extra {
    position: absolute;
    right: 30px;
    top: 20px;
  }
  .roam_panorama {
    width: 100%;
    height: calc(100% - 40px);
    position: relative;
  }
  .roam_content {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
</style>